module.exports = __webpack_public_path__ + "media/iphone.951ebd52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iphone.svg
// module id = ./src/assets/iphone.svg
// module chunks = 0